import { createRootRoute, Outlet } from "@tanstack/react-router";
// import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { Toaster } from "sonner";
import { NotFound } from "@/components/reusable-components/not-found";
import { ScanMatchChooserDialog } from "@/components/inventory/shared/ScanMatchChooserDialog";
import { useDateDisplayStore } from "@/stores/useDateDisplayStore";

function RootComponent() {
  // The central date formatters read the display preference non-reactively via
  // getState(), so toggling AD/BS wouldn't repaint already-rendered screens.
  // Keying the Outlet on the preference remounts the tree so every date updates
  // immediately.
  const dateFormat = useDateDisplayStore((s) => s.dateFormat);
  return (
    <>
      <Outlet key={dateFormat} />
      {/* <TanStackRouterDevtools /> */}
      <Toaster position="bottom-right" richColors />
      <ScanMatchChooserDialog />
    </>
  );
}

export const Route = createRootRoute({
  component: RootComponent,
  notFoundComponent: NotFound,
});
